module.exports = __webpack_public_path__ + "static/media/traffic-alert-road.2b2947d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/traffic-alert-road.svg
// module id = 661
// module chunks = 0